var exports = {
  "n": "xa15a2ab7--4b50f3--link",
  "U": "xa15a2ab7--4b50f3--arrow",
};

module.exports = exports;
